import { darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

/**
 * Contains style information for the choices area page.
 */
export const ChoicesAreaPageStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "relative",
        [theme.breakpoints.down("sm")]: {},
    },
    backIcon: {
        padding: "2px 5px",
        paddingLeft: "95px",
    },
    backTochoices: {
        position: "absolute",
        top: "0px",
        left: "0",
        width: "100%",
        background: "#D0E6C7",
        display: "flex",
        alignItems: "center",
        paddingLeft: "95px",
        gap: "8px",
        "& .arrowIcon": {
            backgroundColor: "#449B23",
            height: "30px",
            width: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            cursor: "pointer",
            "& svg": {
                fontSize: "20px",
            },
        },
        "& > button": {
            fontSize: "12px",
            lineHeight: "18px",
            color: "#3C3C3B",
            background: "transparent",
            fontWeight: 700,
            letterSpacing: "-0.18px",
            textDecoration: "none",
            "&:hover": {
                color: "#3C3C3B",
                background: "transparent",
            },
        },
    },
    backTochoicesArea: {
        gap: "8px",
        display: "flex",
        background: "#D0E6C7",
        alignItems: "center",
        paddingLeft: "10px",
        "& .arrowIcon": {
            backgroundColor: "#449B23",
            height: "30px",
            width: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            cursor: "pointer",
            "& svg": {
                fontSize: "20px",
            },
        },
        "& > button": {
            fontSize: "12px",
            lineHeight: "18px",
            color: "#3C3C3B",
            background: "transparent",
            fontWeight: 700,
            letterSpacing: "-0.18px",
            textDecoration: "none",
            "&:hover": {
                color: "#3C3C3B",
                background: "transparent",
            },
        },
    },
    titleRowHeader: {
        backgroundColor: "#3C3C3B",
        display: "flex",
        flex: "0 0 auto",
        alignItems: "center",
        gap: "30px",
        padding: "20px",
        marginTop: "40px",
        borderBottom: "solid 1px #449B23",
    },
    titleTextRow: {
        "& > h5": {
            fontSize: "21px",
            lineHeight: "25px",
            color: "#fff",
            fontWeight: 700,
            letterSpacing: "-0.53px",
            paddingBottom: "7px",
        },
        "& > p": {
            fontSize: "14px",
            lineHeight: 1.25,
            color: "#fff",
            fontWeight: 400,
            letterSpacing: "-0.23px",
        },
    },
    titleImageRow: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "4px",
        flex: "0 0 auto",
        "& > div:first-child": {
            flex: 1,
        },
        "& > div.MuiCardMedia-root": {
            borderRadius: "50%",
            height: "105px",
            border: "solid 2px #fff",
            width: "105px",
            objectFit: "cover",
        },
        "& > div:last-child": {
            alignItems: "flex-start",
            display: "flex",
            flex: 1,
            justifyContent: "flex-end",
        },
    },
    submitButton: {
        maxWidth: "295px",
        margin: "0 auto",
        padding: "18px 0px",
        "& > button": {
            width: "100%",
        },
    },
    customAccordion: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: "60px",
        marginTop: "36px",
        "& > .MuiPaper-root": {
            width: "100%",
            "& > .MuiButtonBase-root": {
                margin: "0px",
                "& > .MuiAccordionSummary-content": {
                    padding: "10px 0px",
                    gap: "40px",
                },
                "& > .MuiButtonBase-root": {
                    padding: "2px",
                    height: "30px",
                    width: "30px",
                    background: "#449B23",
                    borderRadius: "50%",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "40px",
                },
            },
        },
    },
    productGroupAccordionDetails: {
        padding: "0px",
    },
    productGroupTitleContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flex: "1 1 auto",
        "& > p": {
            fontSize: "14px",
            fontWeight: "bold",
            marginRight: "10px",
            color: "#191919",
            lineHeight: "20px",
            letterSpacing: "-0.28px",
        },
    },
    productGroupCounterContainer: {
        marginLeft: "auto",
    },
    productGroupCounterContainerListRow: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        "& > p": {
            fontSize: "14px",
            color: "#191919",
            lineHeight: "18px",
            fontWeight: 400,
            letterSpacing: "-0.21px",
        },
        "& > p:first-child": {
            fontWeight: 700,
            maxWidth: "50px",
            textAlign: "center",
            minWidth: "30px",
        },
    },
    productGroupChoiceCounterContainer: {
        display: "flex",
        flexDirection: "row",
        marginLeft: "20px",
        alignItems: "center",
        "& > svg": {
            fontSize: "15px",
            stroke: "black",
            strokeWidth: "0.5px",
        },
    },
    productGroupChoiceCounterContainerComplete: {
        color: "#3AAA35",
        "& > svg": {
            stroke: "3AAA35",
        },
    },
    accordion: {
        "& > div.MuiCollapse-container": {
            background: "none",
        },
    },
    accordionSummary: {},
    navigateToArrow: {
        alignItems: "center",
        display: "flex",
        "& svg": {
            fill: "#3aaa35",
            [theme.breakpoints.up("md")]: {
                height: "30px",
                width: "30px",
            },
        },
    },
    [theme.breakpoints.up("md")]: {
        submitButton: {
            padding: "30px 0",
        },
        accordion: {
            "& > div.MuiCollapse-container": {
                backgroundColor: "#F9F9F9",
            },
        },
    },
    [theme.breakpoints.down("sm")]: {
        titleRowHeader: {
            marginTop: "0px",
            boxShadow: "0px -3px 6px #00000029",
            borderRadius: "20px 20px 0px 0",
            flexDirection: "column",
            gap: "10px",
        },
        titleTextRow: {
            textAlign: "center",
            "& > p": {
                fontSize: "10px",
                lineHeight: "15px",
            },
        },
        titleImageRow: {
            "& > div.MuiCardMedia-root": {
                height: "96px",
                marginBottom: "10px",
                width: "96px",
            },
        },
        customAccordion: {
            display: "grid",
            gridTemplateColumns: " 1fr",
            columnGap: "60px",
            marginTop: "36px",
            padding: "0 30px",
            "& > .MuiPaper-root": {
                background: "transparent",
                "& > .MuiButtonBase-root": {
                    "& > .MuiAccordionSummary-content": {
                        padding: "7px 0px",
                        gap: "10px",
                    },
                },
            },
        },
        productGroupTitleContainer: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            flex: "1 1 auto",
            "& > p": {
                fontSize: "10px",

                marginRight: "10px",

                lineHeight: "12px",
            },
        },
        productGroupCounterContainerListRow: {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            "& > p": {
                fontSize: "10px",
                lineHeight: "12px",
                "& > svg": {
                    height: "18px",
                },
            },
        },
    },
}));
